import React from "react";
import translate from "../../../reusable/translate";

const RealizedTypeMeterContainer = React.forwardRef(
  ({ meter, reportId, modifyMeter, disabled }, meterRef) => {
    const meterId = meter.meterId || meter.commitmentOperationMeterRefId;
    return (
      <div ref={meterRef} style={{ borderRadius: "5px" }}>
        <p className="p">
          <b>{translate({ textKey: "sit.reporting.meterIs" })}</b>
        </p>
        <div className="flex-row items-center">
          <input
            className="input-radio"
            type="radio"
            disabled={disabled}
            name={`completed.${meterId}.${reportId}`}
            onChange={() => modifyMeter({ ...meter, currentLevel: "realized" })}
            defaultChecked={meter.currentLevel === "realized"}
          />
          <p className="p">
            {translate({ textKey: "sit.commitment.reports.fullFilled" })}
          </p>
        </div>

        <div className="flex-row items-center">
          <input
            className="input-radio"
            type="radio"
            disabled={disabled}
            name={`completed.${meterId}.${reportId}`}
            onChange={() =>
              modifyMeter({ ...meter, currentLevel: "notRealized" })
            }
            defaultChecked={meter.currentLevel === "notRealized"}
          />
          <p className="p">
            {translate({ textKey: "sit.commitment.reports.notFullfilled" })}
          </p>
        </div>
      </div>
    );
  }
);

export default RealizedTypeMeterContainer;



// WEBPACK FOOTER //
// ./src/components/profile/reports/components/RealizedTypeMeterContainer.jsx